module.exports = __webpack_public_path__ + "static/media/facebook.ef69fc32.svg";